import styled from "styled-components";

export const DateComponentWrapper = styled.div`
  /* @media screen and (min-width: 962px) {
    grid-area: dateContainer;
  } */
  display: flex;
  max-height: 50px;
  column-gap: 5px;
  margin-right: 0.4rem;
  @media screen and (max-width: 1024px) {
    /* margin-bottom: 20px; */
    display: grid;
    grid-template-columns: subgrid;
    grid-column: span 2;
    /* width: 200px; */
  }
`;

export const DateComponentContainer = styled.div`
  display: flex;
  flex-direction: column;
  // justify-content: center;
  border: 1px solid #3a35413b;
  height: 50px;
  /* width: 130px; */
  border-radius: 4px;
  /* padding: 7px 10px; */
  width: 200px;
  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`;
export const DateComponentHeader = styled.label`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 7px;
  display: flex;
  align-items: center;
  color: #8b6697;
  /* padding-left: 13px; */
  text-transform: capitalize;
  margin-bottom: 3px;
`;
export const DateInputCalenderIconContainer = styled.div`
  display: flex;
  // align-items: center;
  width: 100%;

  /* border: 1px solid #3a35413b; */
  position: relative;
  /* border: 1px solid red; */
`;
export const CalenderIcon = styled.img`
  width: 18px;
  height: 20px;
  /* position: absolute; */
  /* right: -3px; */
  /* right: 31px;
  right: 22px;
  top: 4px; */
  z-index: 1;
  @media screen and (max-width: 435px) {
    z-index: 0; //to prevent overlay on mobile
    /* right: 22px; */
  }
  /* touch-action: none; */
  pointer-events: none;
`;

interface CustomInputControllerProps {
  ref: any;
}
export const CustomInputController = styled.button<CustomInputControllerProps>`
  outline: none;
  border: none;
  width: 100%;
  text-indent: 10px;
  display: flex;
  align-items: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #3d0a52;
  background-color: transparent;
`;
interface CustomDateComponentProps {
  max?: any;
  minDate?: string;
}
export const CustomDateComponent = styled.input.attrs({
  // className: "block w-full rounded-md border-gray-300 shadow-sm",
})<CustomDateComponentProps>`
  outline: none;
  border: none;
  width: 100%;
  display: flex;
  align-items: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #3d0a52;
  background-color: transparent;

  ::-webkit-calendar-picker-indicator {
    width: 29px;
    height: 20px;
    position: absolute;
    right: -13px;
    background-color: transparent;
    border: none;
    color: transparent;
    opacity: 0;
    z-index: 5;
  }
`;
